module.exports = __webpack_public_path__ + "2c3cb2734b69ddec29fde3244388aae9.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/aranja.svg
// module id = 401
// module chunks = 0